import PptPage1 from '../PptPage1/PptPage1'
import PptPage2 from '../PptPage2/PptPage2'
import { SliderModels } from '@/types/slider'
import PptPage3 from '../PptPage3/PptPage3'
import PptPage4 from '../PptPage4/PptPage4'
import PptPage5 from '../PptPage5/PptPage5'
import PptPage6 from '../PptPage6/PptPage6'
import PptPage7 from '../PptPage7/PptPage7'
import PptPage8 from '../PptPage8/PptPage8'
import PptPage9 from '../PptPage9/PptPage9'
import PptPage10 from '../PptPage10/PptPage10'

interface Props {
  project: ProjectModels.ProjectDetail
  baseNo: number
  onSliderReady: (sliders: SliderModels.Slider, no: number) => void
}

function OverallPptPage(props: Props) {
  return (
    <>
      <PptPage1 project={props.project} no={props.baseNo + 1} onSliderReady={props.onSliderReady} />
      <PptPage2 project={props.project} no={props.baseNo + 2} onSliderReady={props.onSliderReady} />
      <PptPage3 project={props.project} no={props.baseNo + 3} onSliderReady={props.onSliderReady} />
      <PptPage4 project={props.project} no={props.baseNo + 4} onSliderReady={props.onSliderReady} />
      <PptPage5 project={props.project} no={props.baseNo + 5} onSliderReady={props.onSliderReady} />
      <PptPage6 project={props.project} no={props.baseNo + 6} onSliderReady={props.onSliderReady} />
      <PptPage7 project={props.project} no={props.baseNo + 7} onSliderReady={props.onSliderReady} />
      <PptPage8 project={props.project} no={props.baseNo + 8} onSliderReady={props.onSliderReady} />
      <PptPage9 project={props.project} no={props.baseNo + 9} onSliderReady={props.onSliderReady} />
      <PptPage10
        project={props.project}
        no={props.baseNo + 10}
        onSliderReady={props.onSliderReady}
      />
    </>
  )
}

export default OverallPptPage
